import moment from "moment";
import { BriefProps } from "./props/brief-props.type";

const dateFormat = "YYYY-MM-DD";

const today = () => moment().format(dateFormat);
const prevSevenDays = () => moment().subtract(7, "d").format(dateFormat);

export const filterByTodayDate = (data: BriefProps[]) =>
  data.filter(({ createdDate }: any) => createdDate === today());

export const filterByPrevSevenDays = (data: BriefProps[]) =>
  data.filter(({ createdDate }: any) => createdDate >= prevSevenDays() && createdDate < today());

export const filterByBeforeSevenDays = (data: BriefProps[]) =>
  data.filter(({ createdDate }: any) => createdDate < prevSevenDays());
